import { LegalPage, LegalSection } from "../components/v2/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" updated="31 JULY 2026" testId="terms-page">
      <p>
        Welcome to Sourcecode. By downloading or using the app, you agree to
        these Terms of Service.
      </p>

      <LegalSection heading="The service">
        <p>
          Sourcecode provides personalised energy and timing insights, daily
          readings, and related features based on birth information you supply.
          The app is intended for personal insight and entertainment purposes
          only.
        </p>
      </LegalSection>

      <LegalSection heading="Important disclaimer">
        <p>
          Sourcecode is not medical, psychological, financial, legal, or
          professional advice of any kind. Insights are generated from timing
          calculations and offered for reflection, not as
          statements of fact. You are solely responsible for any decisions
          you make.
        </p>
      </LegalSection>

      <LegalSection heading="Subscriptions and payments">
        <ul className="list-disc pl-6 space-y-2">
          <li>Some features require a paid subscription.</li>
          <li>Payments are processed by Apple through your Apple ID.</li>
          <li>
            Subscription terms, pricing, free trials, and cancellation are
            managed by Apple and shown to you at the time of purchase.
          </li>
          <li>You can manage or cancel your subscription in your Apple ID settings.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Free trial">
        <p>
          If a free trial is offered, it will be clearly stated before you start
          it. After the trial ends, you will be charged unless you cancel
          beforehand.
        </p>
      </LegalSection>

      <LegalSection heading="Acceptable use">
        <p>You agree not to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Attempt to reverse-engineer, scrape, or abuse the service</li>
          <li>Use the app for any unlawful purpose</li>
          <li>Interfere with the normal operation of the app</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Intellectual property">
        <p>
          The app, its design, text, visual system, and underlying calculations
          are owned by us or our licensors. You may not copy, modify, or
          distribute any part of the app without permission.
        </p>
      </LegalSection>

      <LegalSection heading="Limitation of liability">
        <p>
          To the maximum extent permitted by law, we are not liable for any
          indirect, incidental, or consequential damages arising from your use
          of Sourcecode. The app is provided “as is”.
        </p>
      </LegalSection>

      <LegalSection heading="Termination">
        <p>
          We may suspend or stop providing the service at any time. You may
          stop using the app at any time by deleting it.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to these terms">
        <p>
          We may update these Terms of Service. Continued use of the app after
          changes means you accept the updated terms.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          For questions about these Terms, contact us at{" "}
          <a
            href="mailto:b@psyanima.com"
            className="text-[#EC8C3C] hover:text-[#F4F1EC] transition-colors"
            data-testid="terms-contact-email"
          >
            b@psyanima.com
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
